import filterTypeEnum from "../../../../../../components/Filter/enumerations/filterTypeEnum";
import levelEnum from "../../../../../../enumerations/levelEnum";
import { filterKey } from "./filterKeyEnum";

const filterSetup = {
  //FILTER TYPE:
  // 1: with quick search
  // 2: only dropdowns
  filter_type: 1,
  //Filter type 1 will have special quick search on top
  //fill out the data here
  quick_search: {
    title: "normal.account",
    data_index: filterKey.ACCOUNT,
  },
  filters: [
    {
      title: "normal.agent.account",
      data_index: filterKey.AGENT_ACCOUNT,
      /**
       * Currently have 3 types
       * SELECT: dropdown
       * DATE_TIME_RANGE: select start date and end date
       * INPUT: typing the value
       */
      type: filterTypeEnum.INPUT,
      required: false,
    },
    {
      title: "normal.level",
      data_index: filterKey.LEVEL,
      type: filterTypeEnum.SELECT,
      required: false,
      //DATA TYPE: "static" and "api"
      //static is for fixed value, api is for data loaded from API
      //static: add static value_enum inside the setup file
      data_type: "static",
      value_enum: levelEnum,
    },
  ],
};

export { filterSetup };
